import { ChevronDown, LayoutGrid } from 'lucide-react';
import { Link } from 'react-router';

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { SidebarMenuAction, SidebarMenuButton, SidebarMenuItem, useSidebar } from '@/components/ui/sidebar';
import { useLocalStorage } from 'src/hooks/use-local-storage';

const OPEN_STATE_STORAGE_KEY = 'sidebar:applications-open';

type Props = {
  isActive: boolean;
  onNavigate?: () => void;
  children?: React.ReactNode;
};

export function NavApplications({ isActive, onNavigate, children }: Props) {
  const { open: isSidebarExpanded, isMobile } = useSidebar();
  const [isOpen, setIsOpen] = useLocalStorage(OPEN_STATE_STORAGE_KEY, false);

  const isSubmenuVisible = isOpen && (isSidebarExpanded || isMobile);

  return (
    <Collapsible asChild open={isSubmenuVisible} onOpenChange={setIsOpen}>
      <SidebarMenuItem className="flex flex-col data-[state=open]:flex-1">
        <SidebarMenuButton isActive={isActive} asChild tooltip="Applications" onClick={onNavigate}>
          <Link to="/applications">
            <LayoutGrid />
            Applications
          </Link>
        </SidebarMenuButton>
        <CollapsibleTrigger asChild>
          <SidebarMenuAction aria-label="Toggle applications" className="top-3.5 data-[state=open]:rotate-180">
            <ChevronDown />
          </SidebarMenuAction>
        </CollapsibleTrigger>
        <CollapsibleContent className="flex flex-1 flex-col">{children}</CollapsibleContent>
      </SidebarMenuItem>
    </Collapsible>
  );
}
